import { TypedDocumentNode, gql } from '@apollo/client';

import { namedOperations } from '__generated__/operations';
import { useMutation } from 'hooks/graphql/useMutation';

import {
  DestroyReferralMutation,
  DestroyReferralMutationVariables,
} from './__generated__/useDestroyReferral.graphql';

const DESTROY_REFERRAL_MUTATION = gql`
  mutation DestroyReferralMutation($input: destroyReferralInput!) {
    destroyReferral(input: $input) {
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  DestroyReferralMutation,
  DestroyReferralMutationVariables
>;

export const useDestroyReferral = () => {
  const [destroy] = useMutation(DESTROY_REFERRAL_MUTATION, {
    showErrorsWithSnackNotification: true,
  });

  return async (referralId: string) => {
    await destroy({
      variables: {
        input: {
          referralId,
        },
      },
      refetchQueries: [namedOperations.Query.ReferralListQuery],
    });
  };
};
